export const getGoogleUrl = (from: string, invitationToken?: string | null) => {
  const rootUrl = `${import.meta.env.VITE_APP_GOOGLE_ROOT_URL}`;

  const fullFrom = from;

  // Encode state with both redirect path and invitation token if present
  const stateData = invitationToken
    ? JSON.stringify({ from: fullFrom, invitation_token: invitationToken })
    : fullFrom;

  const options = {
    redirect_uri: `${import.meta.env.VITE_APP_BASE_URL}/api/sessions/oauth/google`,
    client_id: import.meta.env.VITE_APP_GOOGLE_CLIENT_ID as string,
    access_type: "offline",
    response_type: "code",
    prompt: "consent",
    scope: [
      `${import.meta.env.VITE_APP_SCOPE_GOOGLE_API}/userinfo.profile`,
      `${import.meta.env.VITE_APP_SCOPE_GOOGLE_API}/userinfo.email`,
    ].join(" "),
    state: stateData,
  };

  const qs = new URLSearchParams(options);

  return `${rootUrl}?${qs.toString()}`;
};
